import { useSearchModel } from "../search-model";
import { useViewData } from "../view-data";
import { useSearchReservationList } from "./use-search-reservation-list-query-data";

type Props = {
	hotelID: string;
};

export const useInitialized = ({ hotelID }: Props) => {
	/**
	 * SearchModel の生成
	 */
	const {
		searchModel,
		// 月の切り替え
		onPrevMonth,
		onNextMonth,
		// 予約タイプかつ日付の選択
		onSelectReservationTypeWithDate,
	} = useSearchModel();

	const {
		// チェックイン日での検索
		reservationListByCInDateQueryData,
		// チェックアウト日での検索
		reservationListByCOutDateQueryData,
		// 宿泊日での検索
		reservationListByStayDateQueryData,
	} = useSearchReservationList({ hotelID, searchModel });

	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({
		reservationListByCInDateQueryData,
		reservationListByCOutDateQueryData,
		reservationListByStayDateQueryData,
		searchModel,
	});

	return {
		//
		// readonly
		viewData,
		//
		// searchable
		searchModel,
		// 月の切り替え
		onPrevMonth,
		onNextMonth,
		// 予約タイプかつ日付の選択
		onSelectReservationTypeWithDate,
	};
};
